import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from 'react';
import {
    Col,
    Dropdown,
    DropdownButton,
    Row,
} from 'react-bootstrap';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import {
    AuthedLayout,
} from '../../../components';
import { useDownloadChart, useSemGrade } from '../../../hook';
import apis from '../../../apis';
import useApexDonutChart, { DonutChartState } from '../../../hook/useApexDonutChart';
import { toast } from 'react-toastify';
import { SightMatrix } from '../../../apis/NoticeApi';

const mapState = (app: ApplicationState) => ({ ...app.auth });
const mapDispatch = ErrorDispatches;

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const sightStatisticChart: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const { yearSem, element: semGradeElement } = useSemGrade();
    const [students, setStudents] = useState<SightMatrix>();
    const chartRef = useRef(null);
    useEffect(() => {
        if (yearSem) {
            toast
                .promise(
                    apis
                        .getSightMatrix(yearSem.year, yearSem.sem)
                        .then(r => {
                            setStudents(r)
                        }),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
                .catch(catchErrorForModal);

        }
    }, [yearSem?.year, yearSem?.sem]);
    const schoolsum = students?.find(s => s.grade === 0);
    console.log(schoolsum);
    const series = schoolsum
        ? [
            (schoolsum.male10 + schoolsum.female10),
            (schoolsum.male11 + schoolsum.female11),
            (schoolsum.male21 + schoolsum.male31 + schoolsum.female21 + schoolsum.female31),
            (schoolsum.allSum01 - schoolsum.allSum1)
        ]
        : [0, 0, 0, 0];
    const labels = ["正常", "配鏡後視力達到標準", "配鏡後視力未達標準", "未接受配鏡矯正"];

    const state: DonutChartState = {
        options: {
            chart: {
                type: 'donut',
            },
            labels: labels,
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '70%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '22px',
                            },
                            value: {
                                show: true,
                                fontSize: '16px',
                                formatter: val => `${val}`
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                label: 'Total',
                                formatter: w => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
                            }
                        }
                    }
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }],
            legend: {
                formatter: function (val, opts) {
                    return val + " - " + opts.w.globals.series[opts.seriesIndex] + "人";
                }
            }
        },
        series: series
    };
    const { element: donutchart } = useApexDonutChart(state);
    const {
        downloadChart,
    } = useDownloadChart({
        chartdata: series,
        yearSem,
        chartRef,
        title: `${user.schools[user.currentSchool].name}${yearSem?.year}學年第${yearSem?.sem}學期_視力統計圖`,
    });


    const handlePrint = () => {
        const chartElement = chartRef.current as HTMLElement | null;

        if (!chartElement) {
            return;
        }

        const printWindow = window.open(
            '',
            '_blank',
            'width=1000,height=800'
        );

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const title =
            `${user.schools[user.currentSchool].name}${yearSem?.year}學年第${yearSem?.sem}學期_視力統計圖`;

        printWindow.document.open();

        printWindow.document.write(`
    <!DOCTYPE html>
    <html lang="zh-Hant">
      <head>
        <meta charset="UTF-8" />

        <title>${title}</title>

        <style>
          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            font-family:
              "Microsoft JhengHei",
              "Noto Sans TC",
              Arial,
              sans-serif;
          }

          .print-page {
            min-height: 277mm;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          h1 {
            margin: 0 0 20px;
            font-size: 20px;
            text-align: center;
          }

          .chart-container {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .chart-container svg {
            max-width: 100% !important;
            height: auto !important;
          }

          .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          @media print {
            body {
              padding: 0;
            }
          }
        </style>
      </head>

      <body>
        <div class="print-page">
          <h1>${title}</h1>

          <div class="chart-container">
            ${chartElement.innerHTML}
          </div>

          <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>
        </div>

        <script>
          window.onload = function () {
            window.focus();

            setTimeout(function () {
              window.print();
            }, 300);
          };

          window.onafterprint = function () {
            window.close();
          };
        </script>
      </body>
    </html>
  `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <Row className="justify-content-between">
                <Col xs={3} className="mr-3">
                    {semGradeElement}
                </Col>
                <Col xs={2} className="mr-1">
                    <DropdownButton
                        id="sight-statistic-chart-export"
                        title="匯出"
                        variant="success"
                        disabled={!schoolsum}
                    >
                        <Dropdown.Item
                            onClick={() => {
                                downloadChart();
                            }}
                        >
                            Excel 下載
                        </Dropdown.Item>

                        <Dropdown.Item onClick={handlePrint}>
                            列印
                        </Dropdown.Item>
                    </DropdownButton>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col className="text-center">
                    {user.schools[user.currentSchool].name}{yearSem?.year}學年第{yearSem?.sem}學期_視力統計圖
                </Col>
            </Row>

            <Row className="justify-content-center">
                <div ref={chartRef}>
                    {donutchart}
                </div>
            </Row>
        </AuthedLayout>
    );
};

export const SightStatisticChart = connector(sightStatisticChart);
